import React from 'react'
import { result, map } from 'libraries/lodash'
import { useSelector } from 'react-redux'
import MuiTableRow from '@mui/material/TableRow'
import IconButton from '@mui/material/IconButton'
import url from 'libraries/front-end-core/core/url'
import { MW_DEAL_DETAILS } from 'constants/controllers'
import Icon from 'components/shared/Icon'
import { LayoutHeader } from 'components/dealwatch/Layout'
import TealToolTip from 'components/TealToolTip'
import Table from './Table'
import TableCell from 'components/dealwatch/TableCell'
import selectAolName from 'redux/selectors/selectAolName'
import ParameterComment from 'pages/mwdealdetails/ParameterComment'

const buildDocumentUrls = ({ param, dealId, valuesCount, aol }) => {
  const paramValues = [
    {
      show: param.descriptor.context.value
    },
    {
      show: param.minValue,
      path: '.minValue'
    },
    {
      show: param.maxValue,
      path: '.maxValue'
    }
  ]

  for (let count = 0; count < valuesCount; count++) {
    paramValues.push({ show: true, path: `.values[${count}]` })
  }

  return paramValues.reduce((acc, { show, path = '' }) => {
    if (show && result(param, (path + '.descriptor.context.value').substr(1))) {
      const docId = result(param, 'descriptor.context.documentUuid', param)
      const paramName = result(param, 'descriptor.name', null)
      const link = url(
        MW_DEAL_DETAILS,
        { aol, dealId },
        { docId, paramName, ...(path && { path }) }
      )

      return [...acc, link]
    }

    return acc
  }, [])
}

const DocumentLink = ({ url }) => (
  <TealToolTip title='See in document' placement='top' leaveDelay={300}>
    <a href={url} className='pointer underline'>
      <IconButton size='small' classes={{ sizeSmall: 'pa3' }}>
        <Icon name='icon-eye' className='w7 dark-sea-green-2' />
      </IconButton>
    </a>
  </TealToolTip>
)

const Parameter = ({ param, dealId }) => {
  const formattedValueList = param.formattedValue.split('; ')
  const aol = useSelector(selectAolName)
  const documentUrls = buildDocumentUrls({ param, dealId, valuesCount: formattedValueList.length, aol })

  return (
    <MuiTableRow className='w-100'>
      <TableCell cxNames='w-30 pv3'>
        {param.config.description}
      </TableCell>
      <TableCell cxNames='pv3 w-50'>
        <ul className='list-reset ma0 pa0 flex flex-column'>
          {formattedValueList.map((value, index) => (
            <li className='mv6' key={index}>{value}</li>
          ))}
        </ul>
      </TableCell>
      <TableCell cxNames='pv0 w-10'>
        <ul className='list-reset ma0 pa0'>
          {documentUrls.map((url, index) => (
            <li className='pv4' key={index}>
              <DocumentLink {...{ url }} />
            </li>
          ))}
        </ul>
      </TableCell>
      <TableCell cxNames='pv0 w-10'>
        <ParameterComment comment={param.comment} />
      </TableCell>
    </MuiTableRow>
  )
}

const DealParameters = ({ params, dealId }) => (
  <>
    <LayoutHeader title='Parameters' />
    {map(params, ({ group, groupName }) => (
      <Table className='mb4' key={groupName} columnTitles={[groupName]}>
        {group.map(param => (
          <Parameter key={param.config.name} {...{ param, dealId }} />
        ))}
      </Table>
    ))}
  </>
)

export default DealParameters
